import React from 'react';
import './SigningInOverlay.css';

// Full-screen "Signing you in…" with a spinner — shown on the return from a
// Google / Facebook redirect (utils/socialSignIn.js) until the page moves on,
// so the sign-in form doesn't flash up in between.
const SigningInOverlay = ({ text = 'Signing you in…' }) => (
  <div className="signing-in-overlay" role="status" aria-live="polite">
    <div className="signing-in-spinner" aria-hidden="true" />
    <p>{text}</p>
  </div>
);

export default SigningInOverlay;
